import {COMMON_FILTERS_COMPONENTS} from "@constants"
import {
	CommonFiltersBrand,
	CommonFiltersCategory,
	CommonFiltersCountry,
	CommonFiltersDateRangeBlock,
	CommonFiltersFavFilter,
	CommonFiltersMetricSelect,
	CommonFiltersProductInStockSwitch,
	CommonFiltersSite,
	CommonFiltersSku,
	CommonFiltersSkuGroup,
	CommonFiltersWithShippingSwitch
} from "./@components"

export const COMPONENTS = {
	[COMMON_FILTERS_COMPONENTS.DATE_RANGE]: CommonFiltersDateRangeBlock,
	[COMMON_FILTERS_COMPONENTS.METRIC]: CommonFiltersMetricSelect,
	[COMMON_FILTERS_COMPONENTS.MARKET]: CommonFiltersCountry,
	[COMMON_FILTERS_COMPONENTS.RETAILER]: CommonFiltersSite,
	[COMMON_FILTERS_COMPONENTS.CATEGORY]: CommonFiltersCategory,
	[COMMON_FILTERS_COMPONENTS.BRAND]: CommonFiltersBrand,
	[COMMON_FILTERS_COMPONENTS.SKU_GROUP]: CommonFiltersSkuGroup,
	[COMMON_FILTERS_COMPONENTS.SKU]: CommonFiltersSku,
    [COMMON_FILTERS_COMPONENTS.FAV_FILTERS]: CommonFiltersFavFilter,
	[COMMON_FILTERS_COMPONENTS.PRODUCTS_IN_STOCK]: CommonFiltersProductInStockSwitch,
	[COMMON_FILTERS_COMPONENTS.WITH_SHIPPING_PRICE]: CommonFiltersWithShippingSwitch
}